import authFetch from './authFetch';
import getConfig from 'next/config';

const {
  publicRuntimeConfig: { ACCOUNTS_SERVICE_HOST },
} = getConfig();

const ESPARK_REFERRER = 'student.esparklearning.com';
const GOOGLE_CLASSROOM_REFERRER = 'classroom.google.com';

async function request(url, options) {
  const response = await authFetch(url, {
    cache: 'default',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    ...options,
  });
  if (!response.ok) {
    throw await response.json();
  }

  if (response.status === 204) {
    return;
  }

  const result = await response.json();
  if (result?.status === false) {
    throw new Error(result.message);
  }

  return result;
}

export default {
  checkCanDownload: async function(contentType, contentId) {
    return await request(
      `/?__call=Auth&action=canDownload&type=${contentType}&id=${contentId}`,
      {
        method: 'POST',
      }
    );
  },
  getMemberCredits: async function(memberId) {
    return await request(
      ACCOUNTS_SERVICE_HOST + `/members/${memberId}/credits`,
      {
        method: 'POST',
        mode: 'cors',
        cache: 'default',
        credentials: 'include',
      }
    );
  },
  getESparkToken: async function(memberId, contentId) {
    return await request(
      ACCOUNTS_SERVICE_HOST + `/members/${memberId}/espark/${contentId}`,
      {
        method: 'GET',
        mode: 'cors',
        credentials: 'same-origin',
      }
    );
  },
  getGoogleClassroomSecret: async function(memberId, contentId) {
    return await request(
      ACCOUNTS_SERVICE_HOST +
        `/members/${memberId}/googleclassroom/${contentId}`,
      {
        method: 'GET',
        mode: 'cors',
        credentials: 'same-origin',
      }
    );
  },
  fetchSinglePlayToken: async function(referrer = null, memberId, contentId) {
    try {
      switch (referrer) {
        case ESPARK_REFERRER:
          return await this.getESparkToken(memberId, contentId);
        case GOOGLE_CLASSROOM_REFERRER:
          return await this.getGoogleClassroomSecret(memberId, contentId);
        default:
          return null;
      }
    } catch (e) {
      console.log(e);
    }
  },
};
